import { setError, startSpinner, stopSpinner } from '@actions/common/actionCreators';
import { HISTORICAL_APPLICATIONS_ACTION_TYPES } from '@constants/actionTypes/historicalApplicationActionTypes';
import endpoints from '@constants/configs/endpoints';
import API from '@services/API';

export const setHistoricalApplicationsBasicInfo = (data: any) => ({
    type: HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_APPLICATIONS_BASIC_INFO,
    payload: data,
});

export const setHistoricalApplicationsInfo = (data: any[]) => ({
    type: HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_APPLICATIONS_INFO,
    payload: data,
});

export const setHistoricalEnrollmentsInfo = (data: any[]) => ({
    type: HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_HISTORICAL_ENROLLMENTS_INFO,
    payload: data,
});

export const setCurrentYear = (data: string) => ({
    type: HISTORICAL_APPLICATIONS_ACTION_TYPES.SET_CURRENT_YEAR,
    payload: data,
});

const actions = { setError, startSpinner, stopSpinner };

export const fetchHistoricalApplicationBasicInfo = (referenceId: string, onError?: () => void) => async (dispatch): Promise<boolean> => {
    try {
        const url = endpoints.MEMBER_APPLICATIONS_HISTORY_BASIC_INFO.processReplacements({
            userProfileId: referenceId,
        });
        const applicationsData = await API.getData(url, dispatch, actions, true);
        if (applicationsData?.data) {
            dispatch(setHistoricalApplicationsBasicInfo(applicationsData.data));
            return true;
        }
        dispatch(setHistoricalApplicationsBasicInfo({}));
        if (applicationsData?.data === null) onError?.();  // explicit server error signal
        return false;
    } catch (error) {
        dispatch(setHistoricalApplicationsBasicInfo({}));
        return false;
    }
};

export const fetchHistoricalApplicationsInfo = (coverageYear: string = '', userProfileId: string = '', encHouseholdId: string = '', callback?: () => void) => async dispatch => {
    try {
        const queryParams = { coverageYear, userProfileId, encHouseholdId };
        const url = endpoints.MEMBER_APPLICATIONS_HISTORY_APPLICATIONS.processReplacements(queryParams);
        const applicationsData = await API.getData(url, dispatch, actions, true);
        if (applicationsData && applicationsData.data) {
            dispatch(setHistoricalApplicationsInfo(applicationsData.data));
        } else {
            dispatch(setHistoricalApplicationsInfo([]));
        }
    } catch (error) {
        dispatch(setHistoricalApplicationsInfo([]));
    } finally {
        callback?.();
    }
};

export const fetchHistoricalEnrollmentsInfo = (coverageYear: string = '', userProfileId: string = '', encHouseholdId: string = '', callback?: () => void) => async dispatch => {
    try {
        const queryParams = { coverageYear, userProfileId, encHouseholdId };
        const url = endpoints.MEMBER_APPLICATIONS_HISTORY_ENROLLMENTS.processReplacements(queryParams);
        const enrollmentsData = await API.getData(url, dispatch, actions, true);
        if (enrollmentsData && enrollmentsData.data) {
            dispatch(setHistoricalEnrollmentsInfo(enrollmentsData.data));
        } else {
            dispatch(setHistoricalEnrollmentsInfo([]));
        }
    } catch (error) {
        dispatch(setHistoricalEnrollmentsInfo([]));
    } finally {
        callback?.();
    }
};
